enum CreateAccountType {
  Normal = 4,
  AutoCreatePassword = 1,
  AutoCreateUsernameAndPassword = 2,
  Confirmedemail = 3
}
export default Object.freeze(CreateAccountType);

